<script lang="ts">
	import { page } from '$app/stores';
	import type { SignUpStepData, SignUpStepOption } from '$lib/types/form';
	import { getTranslate } from '@tolgee/svelte';
	import { createEventDispatcher } from 'svelte';
	import Textarea from '../../../Form/Input/Textarea.svelte';
	import SelectionItem from '../SelectionItem.svelte';
	import Button from '../../../Button/Button.svelte';

	const dispatch = createEventDispatcher();

	const { t } = getTranslate();

  let { supabase } = $page.data
  $: ({ supabase } = $page.data)

	export let step: number;
	export let field: SignUpStepData['field'];
	export let option: SignUpStepOption;
	export let value: string = '';
	export let additionalClass = 'w-full';

	async function handleSubmit() {
		const userId = $page.data.session?.user.id;
		try {
			if (!userId) throw 'error: no userId' + userId;
			console.log(value);
			await supabase
				.from('profiles')
				.update({ [field]: 'other', known_from_other: value })
				.eq('id', userId);
			dispatch('success');
		} catch (error) {
			dispatch('error', { error });
		}
	}
</script>

<div class={additionalClass}>
	<h1 class="font-bold text-xl mb-4">
		{@html $t(`signup.step${step}.headline`)}
	</h1>
	<div
		class="grid grid-col items-center max-h-[420px] pr-5 gap-4 overflow-y-auto overflow-x-hidden"
	>
		<SelectionItem
			additionalClass="w-[99%] !min-h-[80px] gap-11 mb-2 mx-4 mt-1 ring-purple outline-none ring-2 ring-offset-2 hover:bg-white hover:cursor-default hover:pointer-events-none"
			icon={option.id}
			title={option.title}
			data-test={`__signup-step-${step}-${option.id}`}
			cursor="default"
		/>
		<Textarea
			name="other"
			placeholder={$t('signup.formKnownFromOthers.placeholder')}
			additionalClass="w-[99%] gap-11 mb-2 mx-4 mt-1"
			focused={true}
			bind:value
		/>
		<div class="text-center">
			<Button additionalClass="mt-4 mx-4 mb-2" on:click={() => handleSubmit()}>
				{@html $t('signup.formKnownFromOthers.submit_button')}</Button
			>
		</div>
	</div>
</div>
